import {apiWithToken} from '../../../systems/api/index';
import {API_URL} from '../../../systems/globalContant/index';

export default {
    getTransactionDetail: (filters = {}) => apiWithToken.get(API_URL.DEFAULT + '/transactions/' + filters, {params: {}}),
    getTransactionLogs: (filters = {}) => apiWithToken.get(API_URL.DEFAULT + `/logs/transaction/${filters.id}`, {params: {}}),
};
